import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
import DBOperationsComb from "src/utils/dbOperationsComb";

const tableName = Constants.enums.TABLES_NAME_ENUM.PRE_DEFINED_LIST_TABLE;

async function updatePreDefinedList(data) {
  try {
    return await DBOperationsComb.updateData(tableName, data);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
async function getPreDefinedListById(id) {
  try {
    return await DBOperationsComb.getData(tableName, id);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getPreDefinedLists(config, customTableName = null) {
  try {
    console.log("getPreDefinedLists called ");
    return await DBOperationsComb.fetchData(
      {
        tableName: customTableName || tableName,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getPreDefinedLists,
  getPreDefinedListById,
  updatePreDefinedList
};
